export enum MaritalStatus {
	Single = 'single',
	Married = 'married',
	Separated = 'separated',
	Divorced = 'divorced',
	Widowed = 'widowed',
	DomesticPartnership = 'domesticPartnership',
	InRelationship = 'inRelationship',
	PreferNotToSay = 'preferNotToSay',
}
